<header>
  <!-- Breadcrumbs -->
  <nav aria-label="breadcrumb">
    <div class="breadcrumb-container">
      <mat-icon>home</mat-icon>
      <div class="breadcrumb-items">
        <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
          <span class="breadcrumb-item">
            <a *ngIf="!last" [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</a>
            <span *ngIf="last">{{ breadcrumb.label }}</span>
          </span>
          <span *ngIf="!last" class="breadcrumb-divider">/</span>
        </ng-container>
      </div>
    </div>
  </nav>

  <!-- Icons -->
  <div class="icon-container">
    <mat-icon (click)="onNotificationClick()">notifications</mat-icon>
    <mat-icon (click)="onSettingsClick()">settings</mat-icon>
    <mat-icon (click)="onIconClick()">person</mat-icon>
  </div>
</header>
